import api from './api';

export const getRecipientsData = (page, params) => {
  return api.get('admin/Recipient', { params: { page: page, limit: 10, order: 'createdAt', direction: 'DESC', ...params } });
};

export const getRecipientsDataBySearch = (searchItem, search) => {
  return api.get(`admin/Recipient?searchItem=${searchItem}&search=${search}`);
};

export const updateRecipientPercentTax = (recipientId) =>{
  return api.post(`admin/recipient/${recipientId}/update/tax`)
}
